module.exports = __webpack_public_path__ + "static/media/x-23-icon.eecff224.png";